<template>
    <select @change="onChange()" v-model="selectedTeam">
        <option v-for="team in teams" :key="team.name" :value="team.name"> {{ team.title }} </option>
    </select>
</template>

<script>
export default {
    data(){
        return {
            teams: [{name: 'red', title: 'Red Team'}, {name: 'blue', title: 'Blue Team'}],
            selectedTeam: 'red',
        };
    },
    inject: ["game"],
    methods: {
        onChange(updateUnitSelector=true){
            this.game.setPlacingTeam(this.selectedTeam, updateUnitSelector);
        }
    },
    created(){
        this.onChange(false);
        this.game.updaters.teamSelector = team => {this.selectedTeam = team};
    },
}
</script>

<style>

</style>